module.exports = __webpack_public_path__ + "img/halving_chart.c5f18bb4.svg";